import { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { actions } from '@store/app';
import withAuth from '@shared/components/route/withAuth';
import useActions from '@shared/hooks/useActions';
import { navRoutes } from '@shared/constants';
import PageContainer from '@shared/components/page-parts/Container';
import CardsList from '@shared/components/cards-list/CardsList';
import CardItem from '@shared/components/cards-list/CardItem';
import classNames from 'classnames';
import useNavigate from '@shared/router/useNavigate';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    height: '100%',
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.common.paleGrey}`,
    borderRadius: '4px',
    padding: theme.spacing(2),
    gap: theme.spacing(2.4),
    cursor: 'pointer',

    '&:hover': {
      borderColor: theme.palette.primary.main,
    },
  },
  disabledCard: {
    opacity: 0.4,
    cursor: 'unset',
    '&:hover': {
      borderColor: theme.palette.common.paleGrey,
    },
  },
  cardImage: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  img: {
    maxWidth: '100%',
    borderRadius: '4px',
    height: 'auto',
  },
  cardText: {
    flex: 1,
  },
  cardTitle: {
    fontWeight: 700,
    fontSize: '1.6rem',
    color: theme.palette.common.darkBlue,
    marginBottom: theme.spacing(1.25),
  },
  cardDescription: {
    fontSize: '1.1rem',
    color: theme.palette.common.darkBlue,
  },
}));

const Home = withAuth(() => {
  const classes = useStyles();
  const { goTo } = useNavigate();
  const { showMenu } = useActions(actions);

  useEffect(() => {
    setTimeout(() => {
      showMenu();
    }, 3000);
  }, []);

  const renderRoutes = (routes) => {
    return routes.map((route) => {
      if (route.visible === false) {
        return null;
      }

      if (route.subItems?.length > 0) {
        return renderRoutes(route.subItems);
      }

      const handleClick = () => {
        if (route.path && !route.disabled) {
          goTo(route.path);
          showMenu();
        }
      };

      return (
        <CardItem
          key={ route.path || route.name }
        >
          <div
            className={ classNames(classes.cardContent, {
              [classes.disabledCard]: route.disabled,
            }) }
            onClick={ handleClick }
          >
            {route.image && (
              <div className={ classes.cardImage }>
                <img className={ classes.img } src={ route.image } alt={ route.name } />
              </div>
            )}
            <div className={ classes.cardText }>
              <Typography variant="h6" className={ classes.cardTitle }>
                { route.introName ?? route.name }
              </Typography>
              { route.description && (
                <Typography variant="body2" className={ classes.cardDescription }>
                  { route.description }
                </Typography>
              ) }
            </div>
          </div>
        </CardItem>
      );
    });
  };

  return (
    <PageContainer className={ classes.root }>
        <CardsList>
          {renderRoutes(navRoutes)}
        </CardsList>
    </PageContainer>
  );
});

export default Home;
